import { forOwn ,isUndefined, isNull, isNaN, isString, isEmpty, isObject, isArray, pull, cloneDeep } from "lodash";

export function removeEmptyObjects(o: Record<any, any>): Record<any, any> {
    for (const k in o) {
        if (!o[k] || typeof o[k] !== "object") {
            continue;
        }

        removeEmptyObjects(o[k]);
        if (Object.keys(o[k]).length === 0) {
            delete o[k];
            
        }
    }

    return o;
}

export function pruneEmptyObject(obj: Record<string, unknown>): Record<string, unknown> {
    return function prune(current: Record<string, unknown>) {
        forOwn(current, function(value: unknown, key) {
            if (isUndefined(value) || isNull(value) || isNaN(value) ||
                (isString(value) && isEmpty(value)) ||
                (isObject(value) && isEmpty(prune(value as Record<string, unknown>)))) {

                delete current[key];
            }
        });
        if(isArray(current)) {
            pull(current, undefined);
        }

        return current;
    }(cloneDeep(obj));
}
